var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { computed } from "@tldraw/state";
import { warnDeprecatedGetter } from "@tldraw/utils";
import {
  defaultUserPreferences,
  userPrefersDarkUI
} from "../../config/TLUserPreferences.mjs";
class UserPreferencesManager {
  constructor(user, inferDarkMode) {
    this.user = user;
    this.inferDarkMode = inferDarkMode;
  }
  updateUserPreferences = (userPreferences) => {
    this.user.setUserPreferences({
      ...this.user.userPreferences.get(),
      ...userPreferences
    });
  };
  getUserPreferences() {
    return {
      id: this.getId(),
      name: this.getName(),
      locale: this.getLocale(),
      color: this.getColor(),
      isDarkMode: this.getIsDarkMode(),
      animationSpeed: this.getAnimationSpeed(),
      isSnapMode: this.getIsSnapMode()
    };
  }
  /**
   * @deprecated use `getUserPreferences` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get userPreferences() {
    warnDeprecatedGetter("userPreferences");
    return this.getUserPreferences();
  }
  getIsDarkMode() {
    return this.user.userPreferences.get().isDarkMode ?? (this.inferDarkMode ? userPrefersDarkUI() : false);
  }
  /**
   * @deprecated use `getIsDarkMode` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get isDarkMode() {
    warnDeprecatedGetter("isDarkMode");
    return this.getIsDarkMode();
  }
  getAnimationSpeed() {
    return this.user.userPreferences.get().animationSpeed ?? defaultUserPreferences.animationSpeed;
  }
  /**
   * @deprecated use `getAnimationSpeed` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get animationSpeed() {
    warnDeprecatedGetter("animationSpeed");
    return this.getAnimationSpeed();
  }
  getId() {
    return this.user.userPreferences.get().id;
  }
  /**
   * @deprecated use `getId` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get id() {
    warnDeprecatedGetter("id");
    return this.getId();
  }
  getName() {
    return this.user.userPreferences.get().name ?? defaultUserPreferences.name;
  }
  /**
   * @deprecated use `getName` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get name() {
    warnDeprecatedGetter("name");
    return this.getName();
  }
  getLocale() {
    return this.user.userPreferences.get().locale ?? defaultUserPreferences.locale;
  }
  /**
   * @deprecated use `getLocale` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get locale() {
    warnDeprecatedGetter("locale");
    return this.getLocale();
  }
  getColor() {
    return this.user.userPreferences.get().color ?? defaultUserPreferences.color;
  }
  /**
   * @deprecated use `getColor` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get color() {
    warnDeprecatedGetter("color");
    return this.getColor();
  }
  getIsSnapMode() {
    return this.user.userPreferences.get().isSnapMode ?? defaultUserPreferences.isSnapMode;
  }
  /**
   * @deprecated use `getIsSnapMode` instead
   */
  // eslint-disable-next-line no-restricted-syntax
  get isSnapMode() {
    warnDeprecatedGetter("isSnapMode");
    return this.getIsSnapMode();
  }
}
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getUserPreferences", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getIsDarkMode", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getAnimationSpeed", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getId", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getName", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getLocale", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getColor", 1);
__decorateClass([
  computed
], UserPreferencesManager.prototype, "getIsSnapMode", 1);
export {
  UserPreferencesManager
};
//# sourceMappingURL=UserPreferencesManager.mjs.map
